import React,{ Component } from 'react';
import {Route, Switch} from 'react-router-dom';
import * as router from 'react-router-dom';
// import {AppHeader} from "@coreui/react";
import {
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav, AppSidebarMinimizer, AppFooter,
} from '@coreui/react';
import DefaultHeader from './EventTagHeader';
import './Style.css'
import navigationEvent from '../../_event_nav';
import routes from "../../routes";
import {Container} from "reactstrap";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import Cookies from "js-cookie";
import DefaultFooter from "./EventTagFooter";

class EventTagLayout extends Component {

  signOut(e) {
    e.preventDefault();
    Cookies.remove("3c8bed3b2d6ba6d3076ee8d2f588a4dd");
    Cookies.remove("68a6102f6ed24899420170004a0273b8");
    Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
    this.props.history.push('/login')
  }
  componentDidMount(){
    document.title = "EventTags";
  }
  render() {
    return(
      <div className="app">

        <AppHeader fixed>
          <DefaultHeader onLogout={e => this.signOut(e)}/>
        </AppHeader>

        <div className="app-body">
          <AppSidebar className="navBarWidth" fixed display="lg">
            <AppSidebarHeader/>
            <AppSidebarForm/>

            <AppSidebarNav className="navBarWidth" navConfig={navigationEvent} {...this.props}
                           router={router}/>

            <AppSidebarFooter/>
            <AppSidebarMinimizer/>
          </AppSidebar>

          <main className="main margin-left239">
            <AppBreadcrumb appRoutes={routes} router={router}/>
            <Container fluid>

              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component {...props} />
                      )}/>
                  ) : (null);
                })}
              </Switch>

            </Container>
          </main>

        </div>

        <AppFooter>
          <DefaultFooter ROLE={""}/>
        </AppFooter>

      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {


    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
    browserHistoryHandler: (data) => dispatch(actionCreator.browserHistoryHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventTagLayout);


